import React from 'react'

type TProps = { content?: string }

const QuillContent = React.forwardRef<HTMLDivElement, TProps>(
  ({ content }, ref) => {
    if (!content) {
      return null
    }

    return (
      <div className="ql-content ql-container ql-snow">
        <div
          ref={ref}
          dangerouslySetInnerHTML={{ __html: content }}
          className="ql-editor"
        />
      </div>
    )
  }
)

QuillContent.displayName = 'QuillContent'

export default QuillContent
